/* eslint-disable */
// TEMPORARY visual-QA harness — renders the real dashboard components + hero +
// a mock top bar with the toggle, at a public route (/dev/dash-preview) so the
// UI can be screenshotted without logging in. Delete this file + its route.
import React, { useState } from "react";
import "./dashboards.css";
import PageHeader from "../../../components/PageHeader";
import DashboardsHome from "./DashboardsHome";
import DashboardBuilder from "./DashboardBuilder";
import { CREATE_DASHBOARD, GET_DASHBOARDS } from "./dashboardStore";
import { CREATE_PLAYBOOK as PB_CREATE, GET_PLAYBOOK as PB_GET, GET_PLAYBOOKS as PB_LIST } from "../../Playbook/playbookStore";

const RAW = {
  Revenue: [62, 71, 68, 84, 92, 88, 101, 96, 112, 104, 121, 118, 132, 140, 129, 151],
  "Deals Closed": [8, 11, 9, 14, 12, 15, 13, 18, 16, 19, 17, 22, 20, 24, 21, 27],
  "Calls Made": [40, 44, 42, 52, 48, 60, 55, 62, 58, 66, 63, 70, 68, 74, 71, 78],
  "New Customers": [12, 15, 13, 19, 17, 22, 20, 25, 23, 28, 26, 31, 29, 34, 32, 38],
  "Win Rate": [55, 58, 57, 60, 61, 59, 62, 63, 61, 64, 62, 65, 63, 66, 64, 67],
};
const METRICS = [
  { id: "Revenue", title: "Revenue", ids: ["r"], target: 1800, granularity: "day" },
  { id: "Deals Closed", title: "Deals Closed", ids: ["d"], target: 300, granularity: "day" },
  { id: "Calls Made", title: "Calls Made", ids: ["c"], target: 1000, granularity: "day" },
  { id: "New Customers", title: "New Customers", ids: ["n"], target: 400, granularity: "day" },
  { id: "Win Rate", title: "Win Rate", ids: ["w"], target: 100, granularity: "day" },
];
const seriesFor = (id) => (RAW[id] || RAW.Revenue).map((v, i) => ({ timestamp: String(i * 2 + 1), value: v }));
const metricsApi = {
  metrics: METRICS,
  loading: false,
  getMetric: (id) => METRICS.find((m) => m.id === id) || null,
  getSeries: (id) => seriesFor(id),
  getSummary: (id) => {
    const s = seriesFor(id);
    const total = s.reduce((a, p) => a + p.value, 0);
    const m = METRICS.find((x) => x.id === id) || {};
    return { total, target: m.target || 0, deltaPct: 12.4 };
  },
};

const WIDGETS = [
  { _id: "1", metric: "Revenue", chartType: "area", x: 0, y: 0, w: 8, h: 5, options: {} },
  { _id: "2", metric: "Deals Closed", chartType: "stat", x: 8, y: 0, w: 4, h: 3, options: {} },
  { _id: "3", metric: "New Customers", chartType: "stat", x: 8, y: 3, w: 4, h: 3, options: {} },
  { _id: "4", metric: "Calls Made", chartType: "bar", x: 0, y: 5, w: 6, h: 5, options: {} },
  { _id: "5", metric: "Win Rate", chartType: "donut", x: 6, y: 5, w: 3, h: 4, options: {} },
  { _id: "6", metric: "Revenue", chartType: "table", x: 9, y: 5, w: 3, h: 5, options: {} },
];
const iso = (h) => new Date(Date.now() - h * 3600000).toISOString();
const DASHBOARDS = [
  { _id: "a", ownerId: "me", name: "Sales command center", widgets: WIDGETS, visibility: { mode: "private" }, updatedAt: iso(0.3), isDefault: true },
  { _id: "b", ownerId: "me", name: "Team activity", widgets: WIDGETS.slice(0, 4), visibility: { mode: "workspaces" }, updatedAt: iso(30) },
  { _id: "c", ownerId: "other", name: "Company overview", widgets: WIDGETS.slice(0, 3), visibility: { mode: "public" }, updatedAt: iso(90) },
  { _id: "d", ownerId: "other", name: "Admin KPIs", widgets: WIDGETS.slice(0, 2), visibility: { mode: "admins" }, updatedAt: iso(4) },
];

export default function DashPreview() {
  const tab = "dashboards"; // toggle removed — view now picked from the sidebar Analytics dropdown
  const [screen, setScreen] = useState("home");
  const [testMsg, setTestMsg] = useState("");
  const [pbMsg, setPbMsg] = useState("");
  const runCreateTest = async () => {
    setTestMsg("creating…");
    try {
      const r = await CREATE_DASHBOARD({ ownerId: "me", name: "Harness test dashboard", widgets: [] });
      const list = await GET_DASHBOARDS();
      setTestMsg(`✓ created ${r.data?._id} via ${r.local ? "local fallback (no error)" : "server"} — total now ${(list.data || []).length}`);
    } catch (err) {
      setTestMsg(`✗ ERROR: ${err.message}`);
    }
  };
  const runPlaybookTest = async () => {
    setPbMsg("creating + loading…");
    try {
      const c = await PB_CREATE({ title: "Harness test playbook", type: "Playbook" });
      const loaded = await PB_GET(c.data._id);
      const list = await PB_LIST();
      setPbMsg(
        loaded.data
          ? `✓ playbook created + LOADED back "${loaded.data.title}" via ${c.local ? "local fallback" : "server"} — ${(list.data || []).length} total`
          : "✗ created but load returned nothing"
      );
    } catch (err) {
      setPbMsg(`✗ ERROR: ${err.message}`);
    }
  };

  return (
    <div style={{ background: "#eef1f6", minHeight: "100vh", "--gmb-primary": "#1b598e" }}>
      {/* mock top bar (mirrors the real TopBar placement) */}
      <header style={{ height: 56, background: "#fff", borderBottom: "1px solid #eef0f2", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 24px", position: "sticky", top: 0, zIndex: 5 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#0f172a" }}>Company</span>
        </div>
        <div style={{ display: "flex", gap: 18, color: "#98a2b3" }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.7 21a2 2 0 01-3.4 0" /></svg>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-2.82 1.17V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06A1.65 1.65 0 004.6 15a1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 4.6a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06A1.65 1.65 0 0019.4 9c.14.31.22.65.22 1v.09a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z" /></svg>
        </div>
      </header>

      <div style={{ marginTop: 24 }}>
        <PageHeader
          headerText={tab === "dashboards" ? "Dashboards" : "Company Metrics"}
          subheaderText={tab === "dashboards" ? "Build and share your own views from your company metrics." : "Manage and assign company-wide metric templates."}
        />

        {tab === "metrics" ? (
          <div style={{ maxWidth: 1600, margin: "0 auto", padding: "0 32px", color: "#98a2b3", fontSize: 14 }}>
            The real Company Metrics grid renders here on the live page (needs company data).
          </div>
        ) : (
          <div className="db-root" style={{ maxWidth: 1600, margin: "0 auto", padding: "0 32px 40px", "--db-brand": "#1b598e", "--db-brand-soft": "rgba(27,89,142,.10)" }}>
            <div style={{ display: "flex", gap: 8, margin: "0 0 14px" }}>
              <button type="button" className={`db-btn ${screen === "home" ? "primary" : ""}`} onClick={() => setScreen("home")}>Home</button>
              <button type="button" className={`db-btn ${screen === "builder" ? "primary" : ""}`} onClick={() => setScreen("builder")}>Builder</button>
              <button type="button" className={`db-btn ${screen === "new" ? "primary" : ""}`} onClick={() => setScreen("new")}>New (empty)</button>
              <button type="button" className="db-btn" onClick={runCreateTest}>▶ Test create</button>
              <button type="button" className="db-btn" onClick={runPlaybookTest}>▶ Test playbook</button>
              <span style={{ alignSelf: "center", color: (pbMsg || testMsg).startsWith("✗") ? "#f04438" : "#12b76a", fontSize: 12, fontWeight: 600 }}>{pbMsg || testMsg || "preview harness · mock data"}</span>
            </div>
            {screen === "home" ? (
              <DashboardsHome
                dashboards={DASHBOARDS}
                loading={false}
                currentUserId="me"
                onOpen={() => setScreen("builder")}
                onCreate={() => setScreen("builder")}
                onDuplicate={() => {}}
                onRename={() => {}}
                onDelete={() => {}}
                onSetDefault={() => {}}
              />
            ) : (
              <DashboardBuilder
                key={screen}
                dashboard={screen === "new" ? { _id: "empty", name: "Untitled dashboard", widgets: [], visibility: { mode: "private" } } : DASHBOARDS[0]}
                metricsApi={metricsApi}
                onBack={() => setScreen("home")}
                onSaved={() => {}}
                demo
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
